var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items.length
    ? _c(
        "div",
        {
          staticClass: "review-card-supplements d-flex flex-column ga-2",
          attrs: { "data-qa": "review_card_supplements" },
        },
        _vm._l(_vm.items, function (supplement, index) {
          return _c(
            "div",
            {
              key: supplement.dt_created || index,
              staticClass: "review-card-supplements__item text--text pa-4",
              attrs: { "data-qa": "review_card_supplement" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-subtitle-2 mb-2",
                  attrs: { "data-qa": "review_card_supplement_date" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic("Дополнение от")) +
                      " " +
                      _vm._s(
                        _setup.formatSupplementDate(
                          supplement.dt_created,
                          _setup.languageIso
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-body-2",
                  class: {
                    "review-card-supplements__text--truncated": _vm.truncated,
                  },
                  attrs: { "data-qa": "review_card_supplement_text" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.getSupplementHtml(supplement)) +
                      "\n    "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }